export default __webpack_public_path__ + "static/faq-70e38284c8caacbad341ccbfc13bc849.png";